import { render } from "./WidthAwareContainer.vue?vue&type=template&id=366ac134"
import script from "./WidthAwareContainer.vue?vue&type=script&lang=js"
export * from "./WidthAwareContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import Resize from 'quasar/src/directives/resize/Resize.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'directives', {Resize});
